import React from 'react';

import { ExternalLink } from 'features/order-tracker/shared-components/ExternalLink';
import { InfoIcon } from 'features/order-tracker/shared-components/svg';
import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';
import { SAFE_URL_REGEXP } from 'features/order-tracker/utils/constants';
import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';

import { DeliveryTrackingMilestone } from '../DeliveryTrackingMilestone';
import {
  ARRIVED_WITH_YOU_TITLE,
  COURIER_TO_BE_CONFIRMED,
  EXPECTED_DELIVERY_TITLE,
  LEFT_US_TITLE,
  ON_THE_WAY_WITH_TITLE,
} from './constants';

import styles from './styles.module.scss';

export const DeliveriesTracking: React.FC<components.DeliveriesTracking> = ({ delivery, status }) => {
  const { dispatchDate, carrierShortName, deliveryEstimationInfo } = delivery;
  const secondMilestoneTitle = carrierShortName
    ? `${ON_THE_WAY_WITH_TITLE} ${carrierShortName}`
    : COURIER_TO_BE_CONFIRMED;
  const trackingLinkText = `Track on ${carrierShortName} Website`;
  const isDelivered = status === DELIVERY_STATUSES.Delivered;
  const isInProgress = status === DELIVERY_STATUSES.InProgress;
  const isShowTrackOnCourierSiteLink = SAFE_URL_REGEXP.test(delivery.trackingReferenceURL) && isInProgress;

  return (
    <div>
      <div className={styles.trackingInfoMilestones}>
        <DeliveryTrackingMilestone
          key={LEFT_US_TITLE}
          title={LEFT_US_TITLE}
          isCompleted
          className={AQA_ELEMENTS_MARKER_LIST.summaryPage.deliveries.deliveryLeftUs}
        >
          <strong>{dispatchDate}</strong>
        </DeliveryTrackingMilestone>
        {!isDelivered && (
          <DeliveryTrackingMilestone
            key={secondMilestoneTitle}
            title={secondMilestoneTitle}
            isCompleted={isInProgress}
            className={AQA_ELEMENTS_MARKER_LIST.summaryPage.deliveries.deliveryOnTheWay}
          >
            {isShowTrackOnCourierSiteLink && (
              <ExternalLink
                link={delivery.trackingReferenceURL}
                analytics={`${carrierShortName} delivery - ${trackingLinkText}`}
                text={trackingLinkText}
                className={styles.trackingLink}
                withIcon={false}
              />
            )}
          </DeliveryTrackingMilestone>
        )}
        <DeliveryTrackingMilestone
          key={ARRIVED_WITH_YOU_TITLE}
          title={ARRIVED_WITH_YOU_TITLE}
          isCompleted={isDelivered}
          className={AQA_ELEMENTS_MARKER_LIST.summaryPage.deliveries.deliveryArrivedWithYou}
        />
      </div>
      {!isDelivered && (
        <div className={styles.warningInfo}>
          <InfoIcon />
          <p>{EXPECTED_DELIVERY_TITLE}</p>
          <p>{deliveryEstimationInfo}</p>
        </div>
      )}
    </div>
  );
};
